// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__2i8en","loaderOuter":"PageOverlayLoader_loaderOuter__2FuLU"};